import styles from './Logo.module.css'

function Logo () {
    return (

            <div className={styles.div}><h1 className={styles.logo}>LeonardoTomazB.</h1></div>



    )
}

export default Logo